import { dashboardApiV3 } from '#api';
import { FC, useEffect, useRef } from 'react';
import { User, UserV3 } from '#types';
import { Pagination } from '#dashboard/components/pagination.component';
import { userTableHeadersV3 } from '#globals';
import { useAppContext, useSafeState } from '#hooks';
import { SelectPerPageDropdown } from '#dashboard/components/selectPerPageDropdown.component';
import { getFirstAndLastName } from '../../services/helpers';
import { EmailSearchBar } from './emailSearchBar.component';

export const UserTableV3: FC = () => {

    const { setApiStatus, currentEnvironment } = useAppContext();
    const [isLoading, setIsLoading] = useSafeState<boolean>(true)
    const [users, setUsers] = useSafeState<UserV3[]>([]);
    const [pageSize, setPageSize] = useSafeState<number>(10);
    const [currentPage, setCurrentPage] = useSafeState<number>(1);
    const [email, setEmail] = useSafeState<string>('');
    const totalPagesRef = useRef<number>(1);

    const fetchUsers = async () => {
        setIsLoading(true)
        try {
            const response = await dashboardApiV3.getUsers(currentPage, pageSize)
            totalPagesRef.current = Math.ceil(response.data.total / pageSize)
            setUsers([...response.data.users]);
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
        }
    };

    const submitSearch = async () => {
        setIsLoading(true);
        try {
            const response = await dashboardApiV3.searchUsersByEmail(email, false)
            if (!response.data) {
                setApiStatus({ code: 404, message: 'No user found with this email' })
                return;
            }
            setUsers([response.data]);
            setEmail('')
        } catch (error: any) {
            setApiStatus({ code: error?.response?.data?.statusCode, message: error?.response?.data?.message })
        } finally {
            setIsLoading(false)
        }
    };

    const clearSearch = async () => {
        setEmail('')
        await fetchUsers()
    }

    useEffect(
        () => {
            fetchUsers();
        },
        [currentPage, pageSize, currentEnvironment]
    );


    if (isLoading) {
        return <div className="lds-hourglass" />
    }
    return <>
        <div className='pd-m main-dashboard-container mt-s'>
            <div className='three-columns-expand-two'>
                <EmailSearchBar setEmail={setEmail} email={email} submitSearch={submitSearch} clearSearch={clearSearch} />
                <div />
                <SelectPerPageDropdown pageSize={pageSize} setPageSize={setPageSize} setCurrentPage={setCurrentPage} name='Users' />
            </div>
            <table className='center-wrapper table'>
                <thead className="table-header">
                    <tr>
                        {
                            userTableHeadersV3.map(
                                (header: string) => <th className="table-cell" key={header}>{header.toUpperCase()}</th>
                            )
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        users.map(
                            (user: UserV3, index: number) => (
                                <tr key={`${user.uuid}_${String(index)}`} className={'table-row'} onClick={() => window.open(`/users/${user.email}`, '_blank')} >
                                    <td className="table-cell">{user.email}</td>
                                    <td className="table-cell">{user.nanoID}</td>
                                    <td className="table-cell">{user.uuid}</td>
                                    <td className="table-cell">{user.firstName || ''}</td>
                                    <td className="table-cell">{user.lastName || ''}</td>
                                    <td className="table-cell">{user.currentLocation ? <img style={{ width: 30, height: 20, margin: 'auto' }} src={`https://flagcdn.com/w80/${user.currentLocation.toLowerCase()}.png`} /> : ''}</td>
                                </tr>
                            )
                        )
                    }
                </tbody>
            </table>
            <Pagination totalPages={totalPagesRef.current} currentPage={currentPage} setCurrentPage={setCurrentPage} />
        </div>
    </>
}
